import FingoMuiButton from '../../fingo/components/MuiButton';

const MuiButton = {
  ...FingoMuiButton,
  variants: [
    ...FingoMuiButton.variants,
    {
      props: { variant: 'outlined', color: 'primary' },
      style: ({ theme }) => ({
        borderRadius: '8px',
        borderWidth: 2,
        borderColor: theme.palette.primary.main,
        '&:hover': { borderWidth: 2 },
      }),
    },
    {
      props: { variant: 'contained', color: 'primary' },
      style: ({ theme }) => ({
        borderRadius: '8px',
        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        '&:hover': { backgroundColor: theme.palette.primary.main },
      }),
    },
    {
      props: { variant: 'quickFilter' },
      style: ({ theme }) => ({
        border: `1px solid ${theme.palette.secondary.main}`,
        '&:hover': { backgroundColor: theme.palette.secondary.A100 },
        '&.Mui-selected': {
          backgroundColor: theme.palette.secondary.main,
          '&:hover': { backgroundColor: theme.palette.secondary.A600 },
        },
      }),
    },
    {
      props: { variant: 'navbarButton' },
      style: ({ theme }) => ({
        color: theme.palette.common.white,
      }),
    },
  ],
};

export default MuiButton;
